<template>
    <div>
        <DCard
            padding
        >
            <ContractsForm
                ref="createForm"
                :errors="errors"
                :contact="contract"
                :customer="customer"
                :billing-cycles="billingCycles"
                :contract-term-units="contractTermUnits"
                :discount-types="discountTypes"
                :terms-and-conditions="termsAndConditions"
                :active-term-and-condition="activeTermAndCondition"
                :external-id-mapping="externalIdMapping"
                :existing-contract-groups="existingContractGroups"
                :is-addon="isAddon"
                :contract="contract"
                :has-sepa-mandate="hasSepaMandate"
                :payment-methods="paymentMethods"
                :payment-terms="paymentTerms"
                :fulfillment-strategies="fulfillmentStrategies"
                :is-invoice-before-renewal-enabled="isInvoiceBeforeRenewalEnabled"
                :previous-contract-options="previousContractOptions"
                :billing-types="billingTypes"
                :orders="orders"
                :dns-providers="dnsProviders"
                @submit="storeContract"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ContractsForm from '~@/Components/Customers/Contracts/Form'

export default {
    name: 'CustomerContractCreate',
    components: {
        ContractsForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        termsAndConditions: {
            type: Array,
            default: () => { return [] }
        },
        activeTermAndCondition: {
            type: Object,
            default: () => { return {} }
        },
        externalIdMapping: {
            type: Object,
            default: () => { return {} }
        },
        existingContractGroups: {
            type: Array,
            default: () => { return [] }
        },
        isAddon: {
            type: Boolean,
            default: () => false
        },
        addonContract: {
            type: Object,
            default: () => { return {} }
        },
        hasSepaMandate: {
            type: Boolean,
            default: () => false
        },
        paymentMethods: {
            type: Array,
            default: () => { return [] }
        },
        paymentTerms: {
            type: Array,
            default: () => { return [] }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: () => false
        },
        fulfillmentStrategies: {
            type: Array,
            default: () => { return [] }
        },
        orders: {
            type: Array,
            default: () => { return [] }
        },
        previousContractOptions: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        dnsProviders: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            contract: {
                customer_id: this.customer.id,
                contract_id: this.addonContract?.id ?? null,
                product_name: this.addonContract?.productName
            }
        }
    },
    methods: {
        storeContract (form) {
            form.post(this.$route('customers.customers.contracts.store', {
                customer: this.customer.id
            }))
        }
    }
}
</script>
